import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {useNavigate} from "react-router-dom";
import sso from "../../sso";

function Tele_Menu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({row: {}, htitle: "", ma: []});
    let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Hem", url: "/tele", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Status", url: "/tele/stat", icon: "key", fa: "fa fa-key flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Drift", url: "/tele/drift", icon: "play", fa: "fa fa-play flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Statistik", url: "/tele/stik", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f04"] = { fid: "f06", name: "Backoffice", url: "/tele/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "m01", name: "Totalstatus", url: "/tele/stat/total", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m01", name: "Timstatus", url: "/tele/stat/hh", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m01", name: "Samtalslogg", url: "/tele/stat/logg", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "m01", name: "Samtal", url: "/tele/drift/calls", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m02", name: "Köer", url: "/tele/drift/queues", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "m01", name: "Grupper", url: "/tele/stik/grps", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m01", name: "Köer", url: "/tele/stik/queues", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m01", name: "Anknytningar", url: "/tele/stik/ext", fa: "fa fa-bars" } );

    moa["f04"].ma.push( { fid: "m01", name: "Grupper", url: "/tele/bo/konto", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "m01", name: "Köer", url: "/tele/bo/queues", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "m02", name: "Anknytningar", url: "/tele/bo/ext", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    setState({ row : state.row,  ma : [] });

       sso.seo.sfkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({row : state.row, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

		if(state.row) {
		if(state.row.fid == row.fid) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

		if(state.row) {
		if(state.row.fid == row.fid) {
			//css.color = "#ff9900";
			css.color = "#fff";
		}
		}
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Tele_Menu);
